import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

const CALLIE_POPUP_MODAL_CTA_KEY = 'callie_popup_modal'
const CALLIE_INTRO_VIDEO_LOCATION = 'callie_intro_video'
const TRY_CALLIE_ONBOARDING = 'try_callie_onboarding'

export const INTRO_MODAL_CTA_SHOWN = {
  name: TRACKING_EVENT_NAMES.CTA_SHOWN,
  properties: {
    cta_key: CALLIE_POPUP_MODAL_CTA_KEY,
    cta_text: TRY_CALLIE_ONBOARDING,
  },
}

export const INTRO_MODAL_WATCH_VIDEO_CTA_CLICKED = {
  name: TRACKING_EVENT_NAMES.CTA_CLICKED,
  properties: {
    cta_key: CALLIE_POPUP_MODAL_CTA_KEY,
    cta_text: 'watch_one_minute_video',
  },
}

export const INTRO_MODAL_CLOSE_INTERACTION = {
  name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
  properties: {
    action: 'close',
    modal_name: TRY_CALLIE_ONBOARDING,
    location: CALLIE_POPUP_MODAL_CTA_KEY,
  },
}

export const INTRO_VIDEO_CLOSE_INTERACTION = {
  name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
  properties: {
    action: 'close',
    modal_name: TRY_CALLIE_ONBOARDING,
    location: CALLIE_INTRO_VIDEO_LOCATION,
  },
}

export const INTRO_VIDEO_CTA_SHOWN = {
  name: TRACKING_EVENT_NAMES.CTA_SHOWN,
  properties: {
    cta_key: CALLIE_INTRO_VIDEO_LOCATION,
    cta_text: TRY_CALLIE_ONBOARDING,
  },
}

export const INTRO_MODAL_FLOW_STARTED = {
  name: TRACKING_EVENT_NAMES.FLOW_STARTED,
  properties: {
    flow_name: TRY_CALLIE_ONBOARDING,
    flow_location: CALLIE_POPUP_MODAL_CTA_KEY,
  },
}
